import { env } from './env';

/**
 * Legal documents live on the marketing site (apps/landing: oroi.astro, aporrito.astro), not in
 * the SPA, so consent links must be absolute URLs on the landing origin. The DPA is section 7 of
 * the terms page.
 */
export const LEGAL_PATHS = {
  terms: '/oroi/',
  privacy: '/aporrito/',
  dpa: '/oroi/#symvasi-epexergasias',
} as const;

export type LegalDoc = keyof typeof LEGAL_PATHS;

export function legalUrl(doc: LegalDoc, landingUrl: string = env.landingUrl): string {
  return `${landingUrl.replace(/\/+$/, '')}${LEGAL_PATHS[doc]}`;
}
